import React, { useContext } from "react";
import { AssociatedClientDevice } from "@grabcad/company-server-shared/dist/types";
import DeleteSvg from "../../../../../../images/gateways/delete.svg";
import {
    Section,
    SectionHeader,
    SectionTitle,
    CountBadge,
    DeviceList,
    DeviceRow,
    DeviceInfo,
    StatusDot,
    DeviceName,
    DeleteButton,
    DeleteIcon,
    EmptyStateMessage,
} from "./LinkedDevices.styles";
import { ApplicationContext } from "../../../../../../components/ApplicationProvider";

interface Props {
    devices?: AssociatedClientDevice[];
    onDelete: (device: AssociatedClientDevice) => void;
}

const LinkedDevices: React.FC<Props> = ({ devices = [], onDelete }) => {
    const { t } = useContext(ApplicationContext);

    const connectedDevices = devices.filter(({ status }) => status === "ONLINE").length;
    const countTooltip = t("devices.gateways.gateway_card.active_total_devices_tooltip");

    return (
        <Section>
            <SectionHeader>
                <SectionTitle>{t("devices.gateways.gateway_card.linked_devices")}</SectionTitle>

                <CountBadge title={countTooltip} aria-label={countTooltip}>
                    {connectedDevices}/{devices.length}
                </CountBadge>
            </SectionHeader>

            <DeviceList hasScroll={devices.length > 2}>
                {devices.length === 0 ? (
                    <EmptyStateMessage>
                        {t("devices.gateways.gateway_card.no_linked_devices")}
                    </EmptyStateMessage>
                ) : (
                    devices.map((device) => (
                        <DeviceRow key={device.externalPrinterId ?? device.thingName}>
                            <DeviceInfo>
                                <StatusDot online={device.status === "ONLINE"} />

                                <DeviceName>
                                    {device.printerType ?? "Unknown Printer"} - {device.thingName}
                                </DeviceName>
                            </DeviceInfo>

                            <DeleteButton
                                onClick={() => onDelete(device)}
                                aria-label={`Delete ${device.thingName}`}
                            >
                                <DeleteIcon src={DeleteSvg} alt={`Delete ${device.thingName}`} />
                            </DeleteButton>
                        </DeviceRow>
                    ))
                )}
            </DeviceList>
        </Section>
    );
};

export default LinkedDevices;
